import React from 'react';
import { ShieldCheck, ShieldAlert, ShieldQuestion } from 'lucide-react';

/**
 * ClassifierQualityBadge — displays classifier quality status.
 *
 * Shows what percentage of rows have vendor evidence in their description
 * (i.e., pass the "strict" filter vs raw classifier match).
 *
 * Thresholds:
 *   - Green (high): >65% of rows have vendor evidence
 *   - Amber (medium): 40-65% have vendor evidence
 *   - Red (low): <40% have vendor evidence
 */
function ClassifierQualityBadge({ strictVsRawRatio, rawCount, strictCount, compact = false }) {
  if (strictVsRawRatio == null) {
    return null;
  }

  const pct = Math.round(strictVsRawRatio * 100);

  let status, icon, className;
  if (pct >= 65) {
    status = 'High';
    icon = <ShieldCheck size={compact ? 10 : 12} />;
    className = 'vca-classifier-badge--high';
  } else if (pct >= 40) {
    status = 'Medium';
    icon = <ShieldQuestion size={compact ? 10 : 12} />;
    className = 'vca-classifier-badge--medium';
  } else {
    status = 'Low';
    icon = <ShieldAlert size={compact ? 10 : 12} />;
    className = 'vca-classifier-badge--low';
  }

  const tooltipParts = [
    `${pct}% of rows have vendor evidence in description`,
    `${strictCount?.toLocaleString() || 0} strict / ${rawCount?.toLocaleString() || 0} total`,
    'Strict rows have the vendor name in description or supplier field',
  ];

  return (
    <span
      className={`vca-classifier-badge ${className} ${compact ? 'vca-classifier-badge--compact' : ''}`}
      title={tooltipParts.join('\n')}
    >
      {icon}
      <span>{compact ? `${pct}%` : `Evidence: ${status} (${pct}%)`}</span>
    </span>
  );
}

export default ClassifierQualityBadge;
